import {
  MEETING_ROOM_ORDER_ALL,
  MEETING_ROOM_ORDER_CREATE,
  MEETING_ROOM_ORDER_DELETE,
  MEETING_ROOM_ORDER_GET,
  MEETING_ROOM_ORDER_UPDATE,
  MEETING_ROOM_ORDER_ERROR,
} from "../../actions/types"

const initialState = {
  meetingRoomOrder: null,
  isLoading: false,
}
export default function MeetingRoomOrderReducer(state = initialState, action) {
  switch (action.type) {
    case MEETING_ROOM_ORDER_ALL:
      return {
        arr: action.payload?.rows,
        currPage: action.payload?.currPage,
        lastPage: action.payload?.lastPage,
        isLoading: true,
      }
    case MEETING_ROOM_ORDER_GET:
      return {
        ...action.payload,
        isLoading: true,
      }
    case MEETING_ROOM_ORDER_CREATE:
      return { isLoading: false }
    case MEETING_ROOM_ORDER_UPDATE:
      return { isLoading: false }
    case MEETING_ROOM_ORDER_DELETE:
      return { isLoading: false }
    case MEETING_ROOM_ORDER_ERROR:
      return { isLoading: false }
    default:
      return state
  }
}
